import { ThunderboltFilled } from '@ant-design/icons';
import { Alert, Button, Modal } from 'antd';

import styles from './PricingRuleAlertModal.module.scss';

type Props = {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const PricingRuleAlertModal = ({
  isOpen,
  onConfirm,
  onCancel,
}: Props) => (
  <Modal
    className={styles.modal}
    open={isOpen}
    title="Apply your changes?"
    onCancel={onCancel}
    wrapClassName={styles.validationBulkEditModal}
    footer={[
      <Button size="large" key="back" type="ghost" onClick={onCancel}>
        Back to edit
      </Button>,
      <Button key="save" size="large" type="primary" onClick={onConfirm}>
        Save changes
      </Button>,
    ]}
  >
    <Alert
      className={styles.alert}
      message="The pricing rule will be removed from the days you manually edited"
      icon={<ThunderboltFilled size={16} />}
      showIcon
    />
  </Modal>
);
